// This file is generated by PreparedTypesGenerator.php
// Do not edit it manually
// Mirrors Article::PREPARED_TYPES on the backend: these are the pre-packaged Defektur article types.
// They span flowers (gram) and liquids (milliliter), so never assume gram for these types.
export const PREPARED_ARTICLE_TYPES = ["readymade", "milled", "smalls", "xtracts"] as const

export type PreparedArticleType = (typeof PREPARED_ARTICLE_TYPES)[number]

export function isPreparedArticleType(type: string | null | undefined): type is PreparedArticleType {
    return PREPARED_ARTICLE_TYPES.includes(type as PreparedArticleType)
}
